import { useNavigate } from 'react-router';
import { faCheck, faEnvelope } from '@fortawesome/pro-solid-svg-icons';
import { Button } from 'framework/button';
import { PUBLIC } from 'router/routes';

import { EMPTY_FUNCTION } from '../../../../constants';
import { PasswordConfirmationProps } from '../types';

import cn from '../PasswordRequestPage.module.scss';
const { PUBLIC_URL } = process.env;

export const PasswordConfirmation = ({
  resendEmail = EMPTY_FUNCTION,
}: PasswordConfirmationProps) => {
  const navigate = useNavigate();

  return (
    <form className={cn.form} onSubmit={resendEmail}>
      <div className={cn.logo}>
        <img src={`${PUBLIC_URL}/voladeum/voladeum-vertical.png`} alt="Voladeum" />
      </div>
      <Button
        width="100%"
        height="36px"
        variant="secondary"
        left_icon={faCheck}
        onClick={() => navigate(PUBLIC.LOGIN.path)}
        shadow
      >
        Email Delivered
      </Button>
      <div className={cn.row}>
        <div className={cn.break} />
        <p className={cn.text}>OR</p>
        <div className={cn.break} />
      </div>
      <Button
        width="100%"
        height="36px"
        left_icon={faEnvelope}
        variant="secondary"
        type="submit"
        shadow
      >
        Resend Email
      </Button>
    </form>
  );
};
